export default __webpack_public_path__ + "static/media/Oilers.1bf8b3b4.png";